import { Fragment } from "react";
import type { CtcaeCrossReference } from "../types";

type Props = {
  text: string | null;
  crossReferences?: CtcaeCrossReference[];
  onOpenReference?: (recordId: string) => void;
};

export function SourceText({ text, crossReferences = [], onOpenReference }: Props) {
  if (!text) return <span className="unavailable">—</span>;
  if (!crossReferences.length || !onOpenReference) return <>{text}</>;
  let cursor = 0;
  return (
    <>
      {crossReferences.map((reference) => {
        const before = text.slice(cursor, reference.start);
        cursor = reference.end;
        return (
          <Fragment key={`${reference.targetRecordId}:${reference.start}`}>
            {before}
            <button className="source-reference" type="button" onClick={() => onOpenReference(reference.targetRecordId)}>
              {text.slice(reference.start, reference.end)}
            </button>
          </Fragment>
        );
      })}
      {text.slice(cursor)}
    </>
  );
}

